import styled from "styled-components";
import {UserMenuCloseIconDefaultBox} from "./user-menu-close-icon.default.box";

export const UserMenuCloseIconCasino777Box = styled(UserMenuCloseIconDefaultBox)`
  border: 1px solid ${({theme}) => theme.colors.boxBorderContrast};
  border-radius: 5px;
`